module.exports = __webpack_public_path__ + "img/mechanic-medium.ecdb1063.webp";